const baseRoute = {
  path: '/documentation',
  name: 'UiKit',
  component: () => import('@/shared/lib/uikit/BasePage.vue'),
  isAllowWithoutUserCard: true,
  children: [
    {
      path: 'iframe',
      name: 'InnerFrame',
      component: () => import('@/shared/lib/uikit/FramePage.vue'),
      children: [] as any[],
    },
    {
      path: '',
      name: 'BaseUiKit',
      component: () => import('@/shared/lib/uikit/IndexPage.vue'),
      children: [] as any[],
    },
  ],
};

const registerBaseComponent = registerChildComponent.bind(null, 'components', 'Базовые компоненты');
const registerAppComponent = registerChildComponent.bind(null, 'components', 'Компоненты приложения');
const registerDesignSystem = registerChildComponent.bind(null, 'designSystem', 'Дизайн система');
const registerFunctions = registerChildComponent.bind(null, 'functions', 'Функции');

registerDesignSystem('colors', 'Цвета', 'colors');
registerDesignSystem('typography', 'Типографика', 'typography');
registerDesignSystem('variables', 'Переменные', 'variables');
registerDesignSystem('mixins', 'Миксины', 'mixins');
registerDesignSystem('helpers', 'Хэлперы', 'helpers');
registerBaseComponent('button', 'Кнопка', 'BaseButton');
registerBaseComponent('select', 'Выпадающий список', 'BaseSelect');
registerBaseComponent('input', 'Поле ввода', 'BaseInput');
registerBaseComponent('input-code', 'Поле ввода кода', 'BaseInputCode');
registerBaseComponent('checkbox', 'Чекбокс', 'BaseCheckbox');
registerBaseComponent('date-picker', 'Календарь', 'BaseDatePicker');
registerBaseComponent('phone-input', 'Номер телефона', 'BasePhoneInput');
registerBaseComponent('price-slider', 'Слайдер цены', 'BasePriceSlider');
registerBaseComponent('slider', 'Слайдер', 'BaseSlider');
registerBaseComponent('tabs', 'Табы', 'BaseTabs');
registerBaseComponent('toast', 'Уведомление', 'BaseToast');
registerBaseComponent('table', 'Таблица', 'BaseTable');
registerBaseComponent('tags', 'Тэги', 'BaseTags');
registerBaseComponent('accordion', 'Акордион', 'BaseAccordion');
registerBaseComponent('skeleton', 'Скелетон', 'BaseSkeleton');
registerBaseComponent('card', 'Карточка', 'BaseCard');
registerBaseComponent('grid', 'Сетка', 'BaseGrid');
registerBaseComponent('order-history', 'История заказа', 'BaseOrderHistory');
registerBaseComponent('hint', 'Подсказка', 'BaseHint');
registerBaseComponent('dialog', 'Диалоговое окно', 'BaseDialog');
registerBaseComponent('show-more', 'Показать еще', 'BaseShowMore');
registerBaseComponent('alert', 'Предупреждение', 'BaseAlert');
registerBaseComponent('banner-spent', 'Банер потрачено', 'BaseBannerSpent');
registerBaseComponent('icon', 'Иконка', 'BaseIcon');
registerBaseComponent('progress-load', 'Прогрес загрузки', 'BaseLoader');
registerAppComponent('product-card', 'Карточка товара каталога', 'AppProductCard');
registerAppComponent('product-detail-card', 'Детальная карточка товара', 'AppProductDetailCard');
registerAppComponent('order-card', 'Карточка заказа', 'AppOrderCard');
registerAppComponent('go-back', 'Вернуться', 'AppGoBack');
registerAppComponent('app-hint', 'Подсказка всплывающая', 'AppHint');
registerAppComponent('app-page-loader', 'Прелоадер страницы', 'AppPageLoader');
registerFunctions('core', 'Ядро', 'core');
registerFunctions('emoji-eliminate', 'Библиотека эмоджи', 'emoji');
registerFunctions('security', 'Библиотека безопасности', 'security');
registerFunctions('welcome-bonus', 'Библиотека приветственные бонусы', 'welcomeBonus');

export default baseRoute;

function registerChildComponent(
  componentPath: string,
  group: string,
  path: string,
  title: string,
  componentName: string,
) {
  const uiPageName = 'UiPage' + componentName.charAt(0).toUpperCase() + componentName.slice(1);
  const newRoute = {
    path,
    name: `UiComponent${path}`,
    group,
    title,
    isAllowWithoutUserCard: true,
    component: () => import(`@/shared/lib/uikit/${componentPath}/${componentName}/${uiPageName}.vue`),
  };
  baseRoute.children[0].children.push({ ...newRoute, name: newRoute.name + 'Frame' });
  baseRoute.children[1].children.push(newRoute);
};
